/**
 * @author PoornaChandu
 */
import { Button, Checkbox, Drawer, Modal, Select, Skeleton, Space } from 'antd';
import React, { useState, useEffect } from 'react';

import { getParameterList, getRootLevelDataByDT } from './APICalls';
import StyledTable from '../../../commons/styles/table';
import { CaretRightOutlined, EyeOutlined } from '@ant-design/icons';

const DynamicGrid = (props) => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [customModalOpen, setCustomModalOpen] = useState(false);
  const [customValue, setCustomValue] = useState(props.customValue || '');
  const [parameterList, setParameterList] = useState([]);
  const [paramsList, setParamsList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState(props.value);
  useEffect(() => {
    (async () => {
      try {
        let parameterListData = await getParameterList(props.DeviceType);
        setParameterList(parameterListData);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (props.stepWise && props.stepWise.Answer) {
        setItems(
          props.stepWise.Answer.map((option) => ({
            key: option.Value,
            Option: option.Option,
            Value: option.Value,
            highlighted: option.Value === props.value ? true : false
          }))
        );
      }
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  });

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px'
        }}
      >
        <Skeleton />
      </div>
    );
  }

  const onButtonSelect = (value) => {
    setSelectedRowKeys(value);
    props.onSelectChange(value);
  };

  const renderButtonWithCheckbox = (text, record) => {
    const isSelected = selectedRowKeys === record.Value;
    return <Checkbox checked={isSelected} onChange={() => onButtonSelect(record.Value)} />;
  };

  return (
    <>
      <StyledTable size="small"
        columns={[
          {
            title: 'Select',
            key: 'select',
            render: renderButtonWithCheckbox
          },
          {
            title: 'Tag Name',
            dataIndex: 'Value',
            key: 'Value'
          },
          {
            title: 'Tag Description',
            dataIndex: 'Option',
            key: 'Option'
          },
          {
            title: 'Extra info',
            dataIndex: 'extraInfo',
            key: 'extraInfo',
            render: (_text, record) => (
              <Button
                icon={<EyeOutlined />}
                onClick={async () => {
                  let list = await getRootLevelDataByDT(record.Value, props.DeviceType);
                  Modal.info({
                    title: 'Tag at different levels',
                    content: (
                      <div>
                        <CaretRightOutlined />
                        {list && Array.isArray(list)
                          ? list.map((data, index) => {
                              return <div key={index}>{data.MatchedNode}</div>;
                            })
                          : ''}
                      </div>
                    )
                  });
                }}
              ></Button>
            )
          }
        ]}
        dataSource={items}
      />
   

      <Drawer
        title={'Select Tag'}
        open={customModalOpen}
        closable
        extra={
          <Space>
            <Button onClick={() => setCustomModalOpen(false)}>Cancel</Button>
            <Button
              type="primary"
              onClick={() => {
                props.onCustomSelectChange(customValue);
                setCustomModalOpen(false);
              }}
            >
              Submit
            </Button>
          </Space>
        }
        onClose={() => setCustomModalOpen(false)}
        width={600}
      >
        <label>Select Tag: </label>
        <Select
          style={{ width: 300 }}
          onChange={async (value) => {
            setCustomValue(value);
            let parameterListData = await getRootLevelDataByDT(props.DeviceType, value);
            setParamsList(parameterListData);
          }}
        >
          {parameterList &&
            Array.isArray(parameterList) &&
            parameterList.map((param, index) => {
              return (
                <Select.Option key={index} value={param.Code}>
                  {param.Name}
                </Select.Option>
              );
            })}
        </Select>

        {paramsList &&
          Array.isArray(paramsList) &&
          paramsList.map((data, index) => {
            return (
              <div style={{ margin: '5px 0px' }} key={index}>
                {data.MatchedNode}
              </div>
            );
          })}
      </Drawer>
    </>
  );
};

const App = (props) => {
  return (
    <div>
      <DynamicGrid {...props} />
    </div>
  );
};

export default App;
